import { servicesAPI } from "./api"
import { parseServicesCallbackWithValue } from "./api/services"
import { IndicatorsResponse } from "./models/indicator"
import { IIndicatorData } from "../components/indicators"

export const getIndicatorsByIndicatorId = (
    indicatorId: number,
): Promise<IndicatorsResponse> => {
    const payload = {
        indicatorId,
    }
    return servicesAPI.postJSON(
        "CollectDashboardDataForCompositeIndicator",
        payload,
        parseServicesCallbackWithValue<IndicatorsResponse>,
    )
}

export const getIndicatorChartData = (
    indicatorId: number,
): Promise<IIndicatorData> => {
    const payload = {
        indicatorId,
    }
    return servicesAPI.postJSON(
        "GetIndicatorChartData",
        payload,
        parseServicesCallbackWithValue<IIndicatorData>,
    )
}

export const getIndicatorsByWorkspaceId = (
    workspaceId: number,
): Promise<IndicatorsResponse> => {
    const payload = {
        workspaceId,
    }
    return servicesAPI.postJSON(
        "GetDashboardData",
        payload,
        parseServicesCallbackWithValue<IndicatorsResponse>,
    )
}

export const getIndicatorsByIndicatorSchemeId = (
    indicatorSchemeId: number,
): Promise<IndicatorsResponse> => {
    const payload = {
        indicatorSchemeId,
    }
    return servicesAPI.postJSON(
        "GetDashboardDataByIndicatorScheme",
        payload,
        parseServicesCallbackWithValue<IndicatorsResponse>,
    )
}
